import PropTypes from "prop-types";
import Paragraph from "components/typography/Paragraph";
import Block from "components/layout/Block";

const NoContent = ({ title, desctiption }) => (
	<Block flex column alignCenter mt={4}>
		<Paragraph>{title}</Paragraph>
		{desctiption && <Paragraph>{desctiption}</Paragraph>}
	</Block>
);

NoContent.propTypes = {
	title: PropTypes.string,
	desctiption: PropTypes.string,
};

NoContent.defaultProps = {
	title: null,
	desctiption: null,
};

export default NoContent;
